<script setup lang="ts">
  import { storeToRefs } from 'pinia';

  import { Card, CardContent, CardHeader, CardTitle } from '@ui/components/card';

  import EmailSenderRowCard from '@/components/email-senders/EmailSenderRowCard.vue';
  import { useEmailSenders } from '@/store';

  defineProps<{
    disabled?: boolean;
    disabledReason?: string;
  }>();

  const emailSenderStore = useEmailSenders();
  const { globalInboxEmailSenders } = storeToRefs(emailSenderStore);
</script>

<template>
  <div>
    <Card>
      <CardHeader>
        <CardTitle>Global Inbox</CardTitle>
      </CardHeader>
      <CardContent class="flex flex-col w-full gap-5">
        <EmailSenderRowCard
          v-for="emailSender in globalInboxEmailSenders"
          :key="emailSender.id"
          :email-sender="emailSender"
        />
      </CardContent>
    </Card>
  </div>
</template>

<style scoped lang="postcss">
  @reference "../../globals.css";
</style>
